import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { SupportedCultures, getCultureInfo } from '@/utils/localization';
import { setUserLocale } from '@/services/users';
import { setCurrentCulture } from '@/state/global/creators';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { Button } from '@/components/Buttons';
import { useAppDispatch } from '@/utils/hooks';
import { Select, SelectOption, Toast } from '@ygtechnologies/bygr-frontend-component-library';

type Props = {
    // OwnProps
};

const LanguageSettings: React.FC<Props> = (props) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const user = useSelector((state: IState) => state.global.user!);
    const currentCulture = useSelector((state: IState) => state.global.currentCulture);
    const [selectedLanguage, setSelectedLanguage] = useState(currentCulture!.locale);

    const dispatch = useAppDispatch();
    const save = async () => {
        setIsSaving(true);
        const culture = getCultureInfo(selectedLanguage);
        if (user.isLoggedIn) {
            await setUserLocale(culture.locale);
        }

        setCurrentCulture(dispatch, culture);
        setIsSaving(false);
        setIsEditing(false);
        Toast.success(<Trans>Language updated successfully</Trans>);
    };

    const languageOptions: SelectOption[] = SupportedCultures.map((culture) => ({
        label: culture.localName,
        value: culture.locale,
    }));
    return (
        <div>
            <h5>
                <span>
                    <Trans>Language settings</Trans>
                </span>
                {!isEditing && (
                    <Button size="xsmall" onClick={() => setIsEditing(true)} color="link">
                        <Trans>Change</Trans>
                    </Button>
                )}
            </h5>

            <div className="form columns-1 labels-25">
                <div>
                    <label>
                        <Trans>Application language</Trans>
                        {isEditing ? (
                            <Select
                                className="form-control-unstyled"
                                onChange={(nv: any) => setSelectedLanguage(nv.value)}
                                value={languageOptions.find((lo) => lo.value === selectedLanguage)}
                                options={languageOptions}
                            />
                        ) : (
                            <input value={currentCulture!.localName} className="form-control-plaintext" disabled />
                        )}
                    </label>
                </div>
                {isEditing && (
                    <>
                        <div className="buttons">
                            <Button color="tertiary" disabled={isSaving} onClick={(e) => setIsEditing(false)}>
                                <Trans>Cancel</Trans>
                            </Button>
                            <Button onClick={save} color="primary" loading={isSaving}>
                                <Trans>Save</Trans>
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default LanguageSettings;
